import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import batchInsuranceModal from './batchInsuranceModal';
import topTitle from '@/components/title';
import readClauseModal from './components/readClauseModal.vue';
import { getPlanResource, getInsuranceNoticeConfigResource } from './request';
import { COLUMNSPLAN } from './utils';
import { mapState } from 'vuex';
export default {
  data() {
    return {
      insuranceInfo: {},
      checked: false,
      batchVisible: false,
      clauseItem: {},
      readVisible: false,
      COLUMNSPLAN: COLUMNSPLAN,
      tableData: [],
      noticeConfigInfo: [],
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      }
    };
  },
  computed: {
    ...mapState({
      accountInfo: state => state.user.accountInfo
    })
  },
  components: {
    topTitle,
    batchInsuranceModal,
    readClauseModal,
    getPlanResource
  },
  created() {
    console.log('created', this.accountInfo);
    this.insuranceInfo = sessionStorage.getItem('insuranceInfo') ? JSON.parse(sessionStorage.getItem('insuranceInfo')) : {};
    if (!this.insuranceInfo.termsList || !this.insuranceInfo.termsList.length) {
      this.checked = true;
    }
    this.insuranceInfo.termsList && this.insuranceInfo.termsList.forEach((item, index) => {
      let type = item.link.substring(item.link.lastIndexOf('.')).substring(1).toLowerCase();
      if (item.link) {
        item.type = type;
        // const urlid = 'https://view.officeapps.live.com/op/view.aspx?src=';
        item.link = item.link + '#toolbar=0&navpanes=0&scrollbar=0';
      }
    });
    console.log(this.insuranceInfo, 'this.insuranceInfo');
    getPlanResource({
      insuranceId: this.insuranceInfo.id
    }).then(res => {
      this.tableData = res.map(item => {
        var _item$rights, _item$rights2, _item$rights3;
        return {
          ...item,
          rightsName: (item === null || item === void 0 || (_item$rights = item.rights) === null || _item$rights === void 0 ? void 0 : _item$rights.name) || '',
          rightsValue: (item === null || item === void 0 || (_item$rights2 = item.rights) === null || _item$rights2 === void 0 ? void 0 : _item$rights2.value) || '',
          info: (item === null || item === void 0 || (_item$rights3 = item.rights) === null || _item$rights3 === void 0 ? void 0 : _item$rights3.info) || ''
        };
      });
      console.log(this.tableData, 'this.tableData');
      this.pagination.total = res.length;
    });
    this.getInsuranceNoticeConfigResourceFunc();
  },
  methods: {
    toInsurance() {
      if (this.accountInfo.documentUploaded && this.noticeConfigInfo.length) {
        let validateStatus = true;
        this.noticeConfigInfo.forEach(element => {
          if (!element.noticePath) {
            validateStatus = false;
          }
        });
        if (!validateStatus) {
          this.$message.error('请上传全部的投保告知书后再投保');
          return;
        }
      }
      if (!this.accountInfo.workScene && this.accountInfo.workSceneId) {
        this.$message.error('工作场景审核未通过，请先完成审核');
        return;
      }
      this.batchVisible = true;
    },
    getInsuranceNoticeConfigResourceFunc() {
      let params = {
        userId: this.accountInfo.id
      };
      getInsuranceNoticeConfigResource(params).then(res => {
        if (res.length > 0) {
          this.noticeConfigInfo = res;
          console.log(this.noticeConfigInfo, 'this.noticeConfigInfo');
          res.forEach(element => {
            if (element.noticePath) {
              const urlid = 'https://view.officeapps.live.com/op/view.aspx?src=';
              let type = element.noticePath.substring(element.noticePath.lastIndexOf('.')).substring(1).toLowerCase();
              let previewDocx = urlid + element.noticePath;
              let obj = {
                type,
                name: element.noticeTemplateName,
                link: previewDocx
              };
              this.insuranceInfo.termsList.push(obj);
            }
          });
        }
        console.log(this.insuranceInfo.termsList, 'getInsuranceNoticeConfigResourceFunc');
        console.log(res, 'getInsuranceNoticeConfigResourceFunc');
      });
    },
    onChange(e) {},
    toRead(item) {
      this.readVisible = true;
      this.clauseItem = item;
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      // this.getDataFun();
    }
  }
};